var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShared = function SvgShared(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1BD",
    d: "M9.04 8.486c-.457 0-.867.181-1.18.464L3.561 6.45c.03-.139.054-.277.054-.422s-.024-.283-.054-.422l4.25-2.477a1.8 1.8 0 0 0 2.507-.041 1.808 1.808 0 1 0-3.086-1.279c0 .145.024.283.054.422l-4.25 2.477A1.8 1.8 0 0 0 .53 4.75a1.808 1.808 0 0 0 1.278 3.086 1.8 1.8 0 0 0 1.23-.488l4.291 2.501q-.046.19-.048.398c0 .97.79 1.754 1.76 1.754a1.757 1.757 0 1 0 0-3.514"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShared);
export { ForwardRef as ReactComponent };